import { http } from "@/lib/http";

/**
 * Mirrors Vue2's Feeds/ChangeImage.vue -> changeProfileImage(): POST
 * /users/change-profile-image with a base64 JPEG. This is a consumer-facing
 * (not admin) endpoint used by the employee self-service profile page.
 */
export function changeProfileImage({ filename, image, currentImage }) {
  return http
    .post("/users/change-profile-image", { filename, image, currentImage })
    .then((res) => res.data);
}
